import { render, staticRenderFns } from "./ModalPreviewPDF.vue?vue&type=template&id=48ab1c12"
import script from "./ModalPreviewPDF.vue?vue&type=script&lang=js"
export * from "./ModalPreviewPDF.vue?vue&type=script&lang=js"
import style0 from "./ModalPreviewPDF.vue?vue&type=style&index=0&id=48ab1c12&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ab1c12')) {
      api.createRecord('48ab1c12', component.options)
    } else {
      api.reload('48ab1c12', component.options)
    }
    module.hot.accept("./ModalPreviewPDF.vue?vue&type=template&id=48ab1c12", function () {
      api.rerender('48ab1c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewPDF.vue"
export default component.exports